import React from 'react';

const styleHeader = {
  height: '140px',
  backgroundColor: '#fff',
  padding: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
};

const MainHeader = props => {
  const getQueryParams = () => {
    try {
      return props.routeRef.history.location.search;
    } catch (e) {
      return null;
    }
  };
  const sendedBudgetsClick= () => {
    props.routeRef.history.push(`/mis-presupuestos/${getQueryParams()}`);
  }
  return (
    <header style={styleHeader}>
      <div
        style={{
          width: '170px',
          height: '100px',
          visibility: 'hidden'
        }}
        className="u-only-up-mobile"
      >
        hidden
      </div>
      <div>
        <h1 className="main-title__text u-only-up-mobile" style={{ textTransform: 'uppercase' }}>
          Presupuestos
        </h1>
      </div>
      <div className="main-header__option-button u-margin-bottom-small@only-mobile u-margin-top-small@only-mobile">
      <button
          type="button"
          className="button button--secondary u-valign-middle"
          onClick={sendedBudgetsClick}
        >
          ver enviados
        </button>
      </div>
    </header>
  );
};

export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/MainHeader/index.js